import '@/styles/globals.scss'
import '@/styles/reset.scss'
import '@/public//fonts/csiconfont.css'
import "@/styles/swiperSelf.scss"
import type { AppProps } from 'next/app'
import withTheme from '@/theme';
import { message } from 'antd';
import { Provider } from 'react-redux';
import store from '@/store/store';

// 在 _app.js 文件中进行全局配置
message.config({
  top: 300, // 消息框距离顶部的距离
  duration: 3, // 消息框自动关闭的时间（单位：秒）
  maxCount: 3, // 最大显示数量，超过数量时会自动关闭最早的消息框
});

// 动态导入 vconsole，避免 SSR 问题
if (typeof window !== 'undefined') {
  // 动态导入 vconsole，只在客户端执行
  import('vconsole').then(({ default: VConsole }) => {
    new VConsole({
      theme: 'light', // 主题：'light' 或 'dark'
      defaultPlugins: ['system', 'network', 'element', 'storage'], // 默认插件
      maxLogNumber: 1000, // 最大日志数量
      disableLogScrolling: false, // 是否禁用日志滚动
    });
  }).catch(error => {
    console.error('Failed to load vconsole:', error);
  });
}


export default function App({ Component, pageProps }: AppProps) {
  // @ts-ignore
  return (
    <Provider store={store}>
      {withTheme(<Component {...pageProps} />)}
    </Provider>
  )
}
